// extracted by mini-css-extract-plugin
export default {"card":"Card_card__a4LWn","container":"Card_container__Nf4fC","title":"Card_title__ErTvW","description":"Card_description__nsiYq","button":"Card_button__IgwjT"};